// extracted by mini-css-extract-plugin
export var baseButton = "_oy-0";
export var controlsArrowKeys = "_oy-1";
export var controlsResetButton = "_oy-2";
export var lightGameButton = "_oy-4 _oy-0";
export var playAgainButton = "_oy-5 _oy-0";
export var startGameButton = "_oy-3 _oy-0";